import { jsx as l } from "react/jsx-runtime";
import { cx as n } from "../apps/ui/styled-system/css/cx.js";
import { css as c } from "../apps/ui/styled-system/css/css.js";
function i({
  children: o,
  className: t,
  color: r = "inherit",
  style: e,
  ...s
}) {
  return /* @__PURE__ */ l(
    "button",
    {
      className: n(
        c({
          _active: {
            transform: "translateY(1px)"
          },
          _focusVisible: {
            outline: "2px solid var(--color-th_focus)",
            outlineOffset: 2
          },
          borderRadius: 2,
          color: "inherit",
          cursor: "pointer!",
          fontSize: "inherit",
          whiteSpace: "nowrap"
        }),
        t
      ),
      style: {
        color: i.isSpecialColor(r) ? i.specialColors[r] : r,
        ...e
      },
      type: "button",
      ...s,
      children: o
    }
  );
}
((o) => {
  o.specialColors = {
    link: "var(--color-th_link)"
  };
  function t(r) {
    return Object.hasOwn(o.specialColors, r);
  }
  o.isSpecialColor = t;
})(i || (i = {}));
export {
  i as TextButton
};
//# sourceMappingURL=TextButton.js.map
